<template>
  <div class="min-width-huge">
    <TextSearchResult v-bind="passedProps" />
  </div>
</template>

<script>
import TextSearchResult from '@/components/TextSearchResult'
export default {
  name: '',
  components: {
    TextSearchResult
  },
  props: ['payload'],
  data () {
    return {
      textData: []
    }
  },
  computed: {
    passedProps () {
      return {
        searchKeyword: this.$route.query.applicant_text,
        tags: this.payload.applicant.tags || '',
        message: this.payload.applicant.message || '',
        text: this.textData || [],
        applicant: this.payload.applicant,
        isModal: false
      }
    }
  },
  created () {
    this.$network_utils.getResourceTexts({
      current_type: 'Applicant',
      current_resource_id: this.payload.applicant.resource_id
    }).then(response => {
      this.textData = response
    })
  }
}
</script>
